/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'

/* ++++++++++ --------------- EXPORT : COMMENTING CONFIGURATION ADVANCED SECTION - REAL-TIME CAPABILITY : STYLES --------------- ++++++++++ */
export default theme => ({
  realtimecapability: {
    '& .realtimepreview': {
      background: '#061240',
      color: '#FFF',
      borderRadius: pxToEm(30),
      height: pxToEm(40),
      maxWidth: pxToEm(400)
    },
    '& .divider': {
      height: pxToEm(20),
      width: pxToEm(2),
      background: '#FFF'
    },
    '& .circles': {
      display: 'flex',
      alignItems: 'center',
      gap: pxToEm(8),
      marginRight: pxToEm(8),
      '& .circle': {
        background: '#FFF',
        borderRadius: pxToEm(24),
        '&:nth-child(odd)': {
          width: pxToEm(4),
          height: pxToEm(4),
        },
        '&:nth-child(even)': {
          width: pxToEm(8),
          height: pxToEm(8)
        }
      }
    }
  }
});
